var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CasBaseApi } from "../../CasBaseApi";
import { EndpointPlaceholders, Endpoints } from "../../CasEndpoints";
export class CasCustomAttrsApiLegacy extends CasBaseApi {
    constructor(baseUrl, tenantToken, ciamToken, userUuid) {
        super(baseUrl, tenantToken, ciamToken, userUuid);
        this.tenantToken = tenantToken;
        this.ciamToken = ciamToken;
        this.userUuid = userUuid;
    }
    preparePath(path) {
        return path.replace(EndpointPlaceholders.UUID, this.userUuid);
    }
    getCustomAttributes() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request(Endpoints.MarketCustomAttrsUrl, {
                method: "GET",
            });
        });
    }
    write(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const { customer } = yield this.request(this.preparePath(Endpoints.CustomAttrsUrl), {
                body: JSON.stringify({
                    custom_attributes: data,
                }),
                method: "PATCH",
            }, true);
            return {
                dob: customer.dob,
                email: customer.email,
                firstname: customer.firstname,
                lastname: customer.lastname,
            };
        });
    }
    writeConsents(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.write(data);
        });
    }
    getIsUserHasComplaints() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const useRecaptchaInRequest = true;
            const response = yield this.request(`/users/${this.userUuid}/complaints`, { method: "GET" }, useRecaptchaInRequest);
            return (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.has_complaints;
        });
    }
}
//# sourceMappingURL=CasCustomAttrsApiLegacy.js.map